import React, { Fragment, useRef, useState, useEffect, use } from 'react'
import PopUp from '../Common/PopUp';
import Filter from '../Common/Filter';
import Table from '../Common/Table';
import { showToast } from '../Common/Messages';
import { useSelector } from 'react-redux';
import { dateFormat } from '../libs/Util';
import DropdownCheckList from '../Common/DropdownCheckList';

const MenuListManagement = () => {
    const loginInfo = useSelector(state => state.login);
    const loginUserId = loginInfo.userId;

    const [viewItem, setViewItem] = useState(null);
    const [listTitle, setListTitle] = useState('');
    const [popupContent, setPopupContent] = useState(null);
    const [groupList, setGroupList] = useState([]);
    const [newGroup, setNewGroup] = useState(null);
    const [editingIndex, setEditingIndex] = useState(null);
    const [editName, setEditName] = useState('');
    const [selectedGroup, setSelectedGroup] = useState("");
    const [accessType, setAccessType] = useState([]);

    useEffect(() => {
        getMenuList();
        getAccessType();
    }, []);

    useEffect(() => {
        if (groupList.length > 0) {
            const initialGroup = groupList[0].route;
            setSelectedGroup(initialGroup);
            const group = findGroup(groupList, initialGroup);
            setViewItem(group);
            setListTitle(group.title);
        }
    }, [groupList]);

    useEffect(() => {
        if (selectedGroup !== "") {
            const group = findGroup(groupList, selectedGroup);
            setViewItem(group);
            setListTitle(group.title)
        } else {
            setListTitle("")
        }
    }, [selectedGroup]);

    const getMenuList = () => {
        fetch('datas/menu/menu.json', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            }
        }).then((response) => response.json())
            .then((data) => {
                setGroupList(data);
            });
    }

    const getAccessType = () => {
        fetch('datas/oper/accesstype.json', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            }
        }).then((response) => response.json())
            .then((data) => {
                setAccessType(data);
            });
    }

    const findGroup = (groupList, selected) => {
        for (const group of groupList) {
            if (group.route === selected) return group;
            if (group.hasSub) {
                const result = findGroup(group.submenu, selected);
                if (result) return result;
            }
        }
        return null;
    }

    const handleChange = (e, field, value) => {
        setViewItem(prev => { return {...prev, [field]: value === "true"}});
    }

    const handleAddGroup = () => {
        if (!newGroup || newGroup.trim() === '') return;
        SaveUserAuthGroup('A', -1, newGroup);
        setNewGroup(null);
    };

    const handleDeleteGroup = (groupSeq) => {
        SaveUserAuthGroup('D', groupSeq);
    };

    const handleEditGroup = (group) => {
        setEditingIndex(group);
        setEditName(groupList.find(x => x.route === group).groupName);
    };

    const handleSaveEdit = (index) => {
        if (!editName || editName.trim() === '') return;
        const groupSeq = groupList[index].groupSeq;
        SaveUserAuthGroup('U', groupSeq, editName);
        setEditingIndex(null);
    };

    const handleSelectGroup = (e, group) => {
        e.stopPropagation();
        setSelectedGroup(group);
    };

    const SaveUserAuthGroup = (workingTag, groupSeq = -1, groupName = '') => {

    };

    const btnOnPopup = (e, item, index, type) => {
        setPopupContent(item !== null && item !== undefined
            ? renderMoreMenu(e, item, index, type) : null);
    }

    const renderMoreMenu = (e, item, index, type="menu") => {
        return type === "menu" ? 
        (
            <div className="context-menu" style={{ top: e.clientY + 'px', left: e.clientX + 'px'}}>
                <ul>
                    <li onClick={() => handleEditGroup(item.route)}><a className='default'>메뉴명 변경</a></li>
                    <li onClick={() => handleDeleteGroup(item.route)}><a className="nega">삭제</a></li>
                </ul>
            </div>
        )
        : (
            <div className="layer-list admin-more-menu" style={{ top: e.clientY + 'px', left: e.clientX + 'px'}}>
                <div className="box">
                    <ul>
                        {/* <li><a onClick={e => renderSelectedUserInfo(item, index)}>사용자 정보</a></li> */}
                    </ul>
                </div>
            </div>
        );
    }

    const [selected, setSelected] = useState(viewItem?.access ?? []);
    const setItems = (items) => {
        setSelected(items);
    }

    const renderGroupList = () => {
        return viewItem ? (
            <tr>
                <td></td>
                <td>
                    <select value={viewItem.visible === false ? "false" : "true"} onChange={e => handleChange(e, "visible", e.target.value)}>
                        <option value={"true"}>표시</option>
                        <option value={"false"}>숨김</option>
                    </select>
                </td>
                <td>
                    <DropdownCheckList list={accessType} items={viewItem.access} setItems={setItems} align={"center"}/>
                </td>
                <td>

                </td>
            </tr>
        )
        : null
    };

    // const list = renderGroupList();

    const setHeaders = () => {
        return [
            "",
            "메뉴 표시 여부",
            "접근 권한",
            ""
        ];
    };

    const saveMenu = (e) => {
        const group = findGroup(groupList, selectedGroup);
        group.access = selected;
        group.visible = viewItem.visible;
        
        const body = {
            menuPath: "menu/menu",
            menuTreeJson: JSON.stringify(groupList)
        }

        fetch('api/Manager/SaveMenu', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        })
            .then(response => response.json())
            .then(data => {
                if (data.message === "Success") {
                    showToast('success', '저장이 완료되었습니다.', 3000);
                    // 재로딩
                    getMenuList();
                }
            })
            .catch(error => {throw new Error('Error saving menu: ' + error)});
    };
    
    const changeCollapse = (e, data) => {
        e.preventDefault();
        const button = e.currentTarget;
        const ul = button.closest('li').querySelector('ul');
        if (data.collapsed) {
            ul.style.display = 'block';
            data.collapsed = false;
        } else {
            ul.style.display = 'none';
            data.collapsed = true;
        }
    };

    const getMenuTree = (menulist) => {
        return menulist.map((group, index) => (
                <li className={`group-item ${selectedGroup === group.route ? 'selected' : ''}`} key={group.route} onClick={(e) => handleSelectGroup(e, group.route)} style={{display: "block"}}>
                    <a style={{display:"flex"}}>
                        {group.hasSub && (
                            <div className={`btn-expand ${group.collapsed ? 'collapse' : ''}`} onClick={(e) => changeCollapse(e, group)} style={{ transform: group.collapsed ? "rotate(180deg)" : "" }}><i className="icoKdc16 expand"></i></div>
                        )}
                        <div className="group-name-wrap">
                            <i className='icoKdc20 document'></i>
                            {editingIndex === index ? (
                                <input type="text" value={editName} onChange={(e) => setEditName(e.target.value)} autoFocus placeholder="메뉴명을 입력하세요" />
                            ) : (
                                <p className='group-name'>{group.title}</p>
                            )}
                        </div>
                        {/* {editingIndex === group.route ? (
                            <button className="btn-add" onClick={() => handleSaveEdit(index)} style={{background: "transparent"}}>확인</button>
                        ) : (
                            <button onClick={(e) => btnOnPopup(e, group.route, index, "menu")} style={{background: "transparent"}}>
                                <i className='icoKdc24 kebab-24'></i>
                            </button>
                        )} */}
                    </a>
                    {group.hasSub ? 
                        <ul style={{padding: "5px 10px"}}>{getMenuTree(group.submenu)}</ul>
                        : null
                    }
                </li>
            ))
    }

    return (
        <div className="content-scroll">
            <div className="content">
                <div className="content-left">
                    <div className="list-top">
                        <h3 className='list-title'>사이트 메뉴 관리</h3>
                        {/* <button className='btn-add' onClick={() => setNewGroup('')}>
                            <i className='icoKdc24 add-24'></i>
                        </button> */}
                    </div>
                    <ul className='group-list' style={{overflowY: "auto"}}>
                        {getMenuTree(groupList)}
                        {newGroup !== null && (
                            <li className='group-item'>
                                <div className="group-name-wrap">
                                    <i className="icoKdc20 document"></i>
                                    <input type="text" value={newGroup} onChange={(e) => setNewGroup(e.target.value)} autoFocus placeholder="그룹명을 입력하세요" />
                                </div>
                                <button className="btn-cancel" onClick={() => setNewGroup(null)}>취소</button>
                                <button className="btn-add" onClick={handleAddGroup}>확인</button>
                            </li>
                        )}
                    </ul>
                </div>
                <div className="content-right">
                    <h3 className='list-title mb-12'>{listTitle}</h3>
                    <div className="list-tools" style={{display:"flex", justifyContent: "flex-end"}}>
                        <div className={`btns-wrap`}>
                            <button className='btn-appr' onClick={saveMenu}>
                                {/* <i className='icoKdc12 add-12'></i> */}
                                저장
                            </button>
                        </div>
                    </div>
                    <Table className={"userlist"} headers={setHeaders()} list={renderGroupList()} />
                    <PopUp setContent={() => btnOnPopup()} content={popupContent} />
                </div>
            </div>
        </div>
    );
}

export default MenuListManagement;